export default __webpack_public_path__ + "static/media/shape_top_pink.b7854870.png";